import styled, { css } from 'styled-components';

const Input = styled.input`
  padding: 16px 24px;
  outline: none;
  border: 1px solid ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fonts.sizeBase};
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  line-height: 1.15;
  width: 100%;
  -webkit-appearance: none;

  &[type="number"] {
    -moz-appearance: textfield;
  }
  &[type="number"]:hover,
  &[type="number"]:focus {
    -moz-appearance: number-input;
  }
  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }

  &::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: ${props => props.theme.colors.xDarkgray};
    
    ${props =>
    props.error &&
    css`
      color: ${props => props.theme.colors.danger50};
    `}
    line-height: normal !important;
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: ${props => props.theme.colors.xDarkgray};
    
    ${props =>
    props.error &&
    css`
      color: ${props => props.theme.colors.danger50};
    `}
    opacity: 1;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: ${props => props.theme.colors.xDarkgray};
    
    ${props =>
    props.error &&
    css`
      color: ${props => props.theme.colors.danger50};
    `}
    opacity: 1;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${props => props.theme.colors.xDarkgray};
    
    ${props =>
    props.error &&
    css`
      color: ${props => props.theme.colors.danger50};
    `}
  }
  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${props => props.theme.colors.xDarkgray};
    
    ${props =>
    props.error &&
    css`
      color: ${props => props.theme.colors.danger50};
    `}
  }

  &::-ms-clear {
    display: none;
  }

  ${props =>
    props.large &&
    css`
      border: none !important;
      padding: 20px 75px 25px 10px;
      text-align: center;
      font-size: ${props => props.theme.fonts.sizeH1Small};
      color: ${props => props.theme.colors.primary};

      @media screen and (min-width: 370px) {
        padding: 20px 75px;
      }
    `} 

  ${props =>
    props.error &&
    css`
      color: ${props => props.theme.colors.danger};
      border-color: ${props => props.theme.colors.danger};
    `}

  ${props =>
    props.search &&
    css`
      background-image: url('/assets/images/svgstore/search.svg');
      background-repeat: no-repeat;
      background-position: 5px 5px;
      padding-left: 40px;
      border: 1px solid ${props => props.theme.colors.gray};

      ${props =>
        props.error &&
        css`
          border-color: red;
        `};
    `};
`;
export default Input;
